import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import RenderView from "./pages/RenderView";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <Router>
      <Toaster position="top-center" />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/r/:renderId" element={<RenderView />} />
        <Route path="/admin" element={<AdminPage />} />
        {/* Redirect old routes to home */}
        <Route path="/dashboard" element={<LandingPage />} />
        <Route path="/settings" element={<LandingPage />} />
        <Route path="/history" element={<LandingPage />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </Router>
  );
}

export default App;
